/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_share_facebook_tooltip20 = /** @type {(inputs: {}) => string} */ () => {
	return `Share on Facebook`
};

const fr_share_facebook_tooltip20 = /** @type {(inputs: {}) => string} */ () => {
	return `Partager sur Facebook`
};

const de_share_facebook_tooltip20 = /** @type {(inputs: {}) => string} */ () => {
	return `Auf Facebook teilen`
};

const es_share_facebook_tooltip20 = /** @type {(inputs: {}) => string} */ () => {
	return `Compartir en Facebook`
};

const it_share_facebook_tooltip20 = /** @type {(inputs: {}) => string} */ () => {
	return `Condividi su Facebook`
};

const ar_share_facebook_tooltip20 = /** @type {(inputs: {}) => string} */ () => {
	return `شارك على الفيسبوك`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const share_facebook_tooltip20 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.share_facebook_tooltip20(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("share_facebook_tooltip20", locale)
	if (locale === "en") return en_share_facebook_tooltip20(inputs)
	if (locale === "fr") return fr_share_facebook_tooltip20(inputs)
	if (locale === "de") return de_share_facebook_tooltip20(inputs)
	if (locale === "es") return es_share_facebook_tooltip20(inputs)
	if (locale === "it") return it_share_facebook_tooltip20(inputs)
	return ar_share_facebook_tooltip20(inputs)
};
export { share_facebook_tooltip20 as "SHARE_FACEBOOK_TOOLTIP" }